export const MAX_APPOINTMENT_REASON_LENGTH = 2000;

/** Suggested reason pills in the Composer. Free text is also accepted. */
export const APPOINTMENT_REASONS: readonly string[] = [
    'Records update',
    'Aligner fitting check',
    'Aligner delivery',
    'Retainer delivery',
    'IPR / attachments',
    'Progress check',
    'Consultation'
];
